export function formatTaxUsage(usageCount: number): string {
  return usageCount > 1 ? `${usageCount} produits ou paniers` : `${usageCount} produit ou panier`;
}
